module.exports = __webpack_public_path__ + "img/05.312c1d41.jpg";